import { g as getRoomType } from './get-room-type.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * Hoteliers Dot Guru
 */
const factory = function factory({ document, thn }) {
    let refreshPrice;
    const roomDetailsParseData = (numAdults, numChildren) => {
        const roomsArray = Array.from(document.querySelectorAll('.room'));
        if (thn.empty(roomsArray)) {
            return [];
        }
        const roomsInfo = roomsArray
            .map((room) => {
            const roomName = room.querySelector('.room_title')?.textContent?.trim() || '';
            const roomType = getRoomType(roomName);
            const ratesInfo = Array.from(room.querySelectorAll('.rate-items')).map((rate) => {
                const rateName = rate.querySelector('.room-rate_title')?.textContent;
                const ratePrice = thn.parseNumber(rate.querySelector('.rate-price_night span:nth-child(2)')?.textContent);
                const hasBreakfast = !!room.querySelector('breakfast-included');
                const isRefundable = !!rateName?.toLowerCase().match(/flexible|ยืดหยุ่นได้/);
                if (!rateName || !ratePrice) {
                    return null;
                }
                const rateData = {
                    name: rateName,
                    totalNight: ratePrice,
                    breakfast: hasBreakfast,
                    refundable: isRefundable,
                };
                return rateData;
            })
                .filter((value) => value !== null);
            if (!roomName) {
                return null;
            }
            const roomData = {
                name: roomName,
                adults: numAdults || 2,
                children: numChildren || 0,
                type: roomType,
                prices: ratesInfo,
            };
            return roomData;
        });
        return roomsInfo.filter((value) => value !== null);
    };
    const hotelIdDicctionary = {
        1156951: '5121',
        1156952: '4138',
    };
    return {
        generateSearchUrl(ctx) {
            /** https://ibe.hoteliers.guru/ibe/search-room-rate?language=en&check_in=2025-07-21&check_out=2025-07-27&
             * chknoofroom=2&total_adult[0]=1&total_child[0]=0&total_adult[1]=1&total_child[1]=2&age_of_child[1][0]=5&
             * age_of_child[1][1]=9&promoCode=&hotel_id=5121
            */
            const url = new URL(ctx.baseUrl);
            const validUrl = url.hostname.match(/ibe.hoteliers.guru/) && url.pathname.match(/ibe/);
            if (!validUrl) {
                return ctx;
            }
            for (const key of Array.from(url.searchParams.keys())) {
                if (key.includes('child') || key.includes('adult')) {
                    url.searchParams.delete(key);
                }
            }
            url.pathname = '/ibe/search-room-rate';
            url.searchParams.delete('tid');
            url.searchParams.delete('boxType');
            url.searchParams.set('language', '[language]');
            url.searchParams.set('check_in', '[date_begin]');
            url.searchParams.set('check_out', '[date_end]');
            url.searchParams.set('chknoofroom', ctx.data.roomsDispo?.length?.toString() ?? '1');
            if (ctx.data.roomsDispo) {
                for (let i = 0; i < ctx.data.roomsDispo.length; i += 1) {
                    const adults = ctx.data.roomsDispo[i]?.adults?.toString() ?? '';
                    const children = ctx.data.roomsDispo[i]?.children?.toString() ?? '';
                    const childrenAges = ctx.data?.roomsDispo?.[i]?.childrenAges ?? [];
                    url.searchParams.set(`total_adult[${i}]`, adults);
                    url.searchParams.set(`total_child[${i}]`, children);
                    for (let j = 0; j < childrenAges.length; j += 1) {
                        url.searchParams.set(`age_of_child[${i}][${j}]`, String(childrenAges[j]));
                    }
                }
            }
            url.searchParams.set('hotel_id', hotelIdDicctionary[thn.data.propertyId]);
            ctx.newData.dateBegin = ctx.data.dateBegin.replace(/\//g, '-');
            ctx.newData.dateEnd = ctx.data.dateEnd.replace(/\//g, '-');
            ctx.newUrl = url.toString();
            return ctx;
        },
        languageCheck(ctx) {
            return new Promise((resolve, reject) => {
                const lang = document.querySelector('#languageSelector')?.value;
                if (lang && ctx.langs.test(lang)) {
                    resolve(lang);
                    return;
                }
                reject(new Error('no_language'));
            });
        },
        priceObserveDom(ctx) {
            const resultContainer = document.querySelector('.main-content, .list-room-available');
            if (resultContainer && !refreshPrice) {
                refreshPrice = thn.debounce(() => ctx.widget.refresh(), 800);
                thn.observeDom(resultContainer, refreshPrice, {
                    attributes: false,
                    childList: true,
                    subtree: true,
                });
                thn.pageUnload(() => {
                    if (refreshPrice) {
                        refreshPrice.cancel();
                        thn.stopObserveDom(resultContainer, refreshPrice);
                        refreshPrice = null;
                    }
                });
            }
        },
        isUserLogged() {
            const isLogged = !!document.querySelector('[ng-click="requestSignOut()"]');
            return isLogged;
        },
        priceParseData() {
            // Guests, Adults & Children
            const selectRoomElement = document.querySelector('#selectRoom');
            const selectedRoomIndex = selectRoomElement && selectRoomElement.selectedIndex + 1;
            const currentRoomNumber = thn.parseNumber(document.querySelector('.current-room span')?.textContent?.split('/')[0]) || 1;
            const roomNum = selectedRoomIndex || currentRoomNumber;
            const adults = thn.parseNumber(document.querySelectorAll('[ng-repeat*="roomDataItem in"] [ng-model="roomDataItem[\'totalAdult\']"]')[roomNum - 1]?.value) || 2;
            const children = thn.parseNumber(document.querySelectorAll('[ng-repeat*="roomDataItem in"] [ng-model="roomDataItem[\'totalChild\']"]')[roomNum - 1]?.value) || 0;
            const childrenAgesRoom = document.querySelectorAll('[ng-repeat*="roomDataItem in"] [ng-show="roomDataItem[\'totalChild\']"], .item-room-content')[roomNum - 1];
            const roomsDispo = [];
            const roomInfo = {
                adults: adults || 1,
                children: children || 0,
                childrenAges: [],
            };
            for (let i = 0; i < children; i += 1) {
                roomInfo.childrenAges = Array.from(childrenAgesRoom.querySelectorAll('[ng-model*="roomDataItem[\'ageOfChildList\']"], [ng-model="ageOfChild"]')).map((age) => (thn.parseNumber(age?.value) === 0 ? 1 : thn.parseNumber(age?.value))).filter((value) => typeof value !== 'undefined');
            }
            roomsDispo.push(roomInfo);
            // Dates
            const dateBeginInput = document.querySelector('[ng-model="arrivalDate"]')?.value;
            const dateEndInput = document.querySelector('[ng-model="departureDate"]')?.value;
            const dateBegin = dateBeginInput && translateDate(dateBeginInput, thn.data.language);
            const dateEnd = dateEndInput && translateDate(dateEndInput, thn.data.language);
            const nights = (dateBegin && dateEnd) && thn.daysBetween(dateBegin, dateEnd);
            if (!dateBegin || !dateEnd) {
                return null;
            }
            // Prices & Currency || No Rooms
            const pricesArray = Array.from(document.querySelectorAll('.rate-price_night span:nth-child(2), .rates-price span:nth-child(2)')) ?? [];
            const prices = pricesArray.map((price) => thn.parseNumber(price.textContent)).filter((value) => typeof value !== 'undefined');
            const currency = thn.parseCurrency(document.querySelector('.select-currency, #exchange')?.value);
            if (!thn.empty(prices) && currency && nights) {
                return {
                    dateBegin,
                    dateEnd,
                    roomsDispo,
                    roomDetails: roomDetailsParseData(roomsDispo[0]?.adults, roomsDispo[0]?.children),
                    price: Math.min(...prices),
                    currency,
                };
            }
            if (thn.empty(prices)) {
                return {
                    roomsDispo,
                    currency,
                    dateBegin,
                    dateEnd,
                    noRooms: true,
                };
            }
            return null;
        },
        bookingParseData() {
            // Booking ID
            const bookingId = thn.dataLayerHelper.get('bookingNumber');
            if (!bookingId) {
                return {
                    set: false,
                };
            }
            // Dates
            const checkInDate = thn.dataLayerHelper.get('checkInDate') || '';
            const checkOutDate = thn.dataLayerHelper.get('checkOutDate') || '';
            const dateBegin = checkInDate?.replace(/-/g, '/');
            const dateEnd = checkOutDate?.replace(/-/g, '/');
            // Price & Currency
            const price = thn.parseNumber(thn.dataLayerHelper.get('price'));
            const currency = thn.parseCurrency(thn.dataLayerHelper.get('currency'));
            return {
                bookingId,
                dateBegin,
                dateEnd,
                price,
                currency,
            };
        },
    };
};

export { factory };
